import React, { useState } from 'react';
import { Modal, Input } from 'antd';

const { TextArea } = Input;

const MessageModal = ({ isVisible, onClose, onSend, profile }) => {
    const [message, setMessage] = useState('');

    const handleSend = () => {
        if (message.trim()) {
            onSend(message);
            setMessage('');
            onClose();
        }
    };

    return (
        <Modal
            title={`Envoyer un message à ${profile?.name}`}
            open={isVisible}
            onCancel={onClose}
            onOk={handleSend}
            okText="Envoyer"
            cancelText="Annuler"
            okButtonProps={{ disabled: !message.trim() }}
        >
            <TextArea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Écrivez votre message..."
                autoSize={{ minRows: 3, maxRows: 6 }}
                maxLength={500}
                showCount
            />
        </Modal>
    );
};

export default MessageModal;
